const containString = ({
  original,
  search,
}: {
  original: string;
  search: string;
}) => original.toLowerCase().includes(search.toLowerCase());

const beetweenDates = ({
  start_date,
  end_date,
  search,
}: {
  start_date: number;
  end_date: number;
  search: number;
}) => start_date <= search && end_date >= search;

const Search = (search: string, originalObject: TListModelsOrVersions) => {
  if (search) {
    let filteredArray = {};

    Object.keys(originalObject).map((entry) => {
      const filtered = originalObject[entry].filter((subentry) => {
        subentry.end_date = subentry.end_date
          ? subentry.end_date
          : new Date().getFullYear();

        const nameHasPartial = containString({
          original: subentry.name,
          search,
        });
        const dateStartHasPartial = containString({
          original: subentry.start_date.toString(),
          search,
        });
        const dateEndHasPartial = containString({
          original: subentry.start_date.toString(),
          search,
        });
        const isBeetweenDates = beetweenDates({
          start_date: subentry.start_date,
          end_date: subentry.end_date,
          search: parseInt(search),
        });

        return (
          nameHasPartial ||
          dateStartHasPartial ||
          dateEndHasPartial ||
          isBeetweenDates
        );
      });

      if (filtered.length > 0) {
        filteredArray = {
          [entry]: filtered,
          ...filteredArray,
        };
      }
    });

    return filteredArray;
  }

  return originalObject;
};

export default Search;
